import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    const sessionToken = api.defaults.headers.Authorization

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Desconectado do servidor Socket.IO:", reason);
      // FIX 16/06: nulificar this.socket antes de reconectar - senao connect() ve socket
      // existente (mesmo morto) e nao faz nada, deixando zumbi ate F5
      try { this.socket && this.socket.removeAllListeners(); } catch (_) {}
      this.socket = null;
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {
    if (!this.socket) {
      this.connect();
    }
    
    if (!this.socket || typeof this.socket.on !== 'function') {
      console.warn(`[SocketWorker] Tentativa de registrar listener '${event}' com socket não disponível`);
      return;
    }
    
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    if (!this.socket) {
      this.connect();
    }
    
    if (!this.socket || typeof this.socket.emit !== 'function') {
      console.warn(`[SocketWorker] Tentativa de emitir evento '${event}' com socket não disponível`);
      return;
    }
    
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    if (!this.socket) {
      return;
    }
    
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        // FIX 16/06: atualizar token do axios (pode ter sido renovado por RefreshToken
        // enquanto socket estava caido) antes de re-handshake com backend
        try { this.token = api.defaults.headers.Authorization; } catch (_) {}
        // FIX 16/06: forcar recreate em vez de connect() - configureSocket abre socket novo
        this.configureSocket();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  // FIX 16/06: recria tambem se socket morto/disconnected (antes so se null)
  connect() {
    if (!this.socket || !this.socket.connected) {
      try { this.token = api.defaults.headers.Authorization; } catch (_) {}
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;